<div class="group/wrapper relative w-full">
    <div
        class="hover:border-blue hover:text-blue relative flex w-full cursor-pointer items-center justify-between gap-16 overflow-visible border-2 transition-all"
        [ngClass]="{
            'border-grey-400 bg-white text-black': theme() === 'light' || theme() === 'dark',
            'bg-accent border-white text-white': theme() === 'medium',
            'border-red': error() && !focussed(),
            '!border-grey-300': disabled(),
            'h-[51px]': !wrapValue(),
            'min-h-[51px]': wrapValue(),
        }"
        [attr.title]="value() ?? ''"
        (click)="clicked.emit()"
    >
        @if (label()) {
            <label
                class="pointer-events-none absolute left-4 flex w-max -translate-y-1/2 items-center justify-center px-12 transition-transform"
                [attr.for]="inputId()"
                [ngClass]="{
                    'bg-white text-black': theme() === 'light' || theme() === 'dark',
                    'bg-accent text-white': theme() === 'medium',
                    'text-12 h-[12px] -translate-x-[4px] -translate-y-[30px] py-2 leading-0': focussed() || value(),
                    '!text-red': error() && !focussed(),
                    '!text-grey-400': disabled(),
                    'top-1/2': !wrapValue(),
                    'top-[calc((51px-4px)/2)]': wrapValue(),
                }"
            >
                {{ label() }}
            </label>
        }

        <ng-content>
            @if (valueOrPlaceholder(); as text) {
                <span
                    class="text-16 min-w-0 flex-1 py-12 pl-16 text-transparent"
                    [ngClass]="{
                        '!text-grey-400 !select-auto': disabled(),
                        '!text-red !select-auto': error() && !focussed(),
                        '!text-black !select-auto':
                            (focussed() || value() || !label()) && (theme() === 'light' || theme() === 'dark'),
                        '!text-white !select-auto': (focussed() || value() || !label()) && theme() === 'medium',
                        'line-clamp-1 overflow-hidden leading-36': !wrapValue(),
                        'leading-25 break-words': wrapValue(),
                    }"
                >
                    {{ text }}
                </span>
            }
        </ng-content>
        <div class="ml-auto py-12 pr-16 empty:hidden">
            <ng-content select="[trailing]" />
        </div>
    </div>
    @if (error() && errorMsg() && !focussed()) {
        <div class="h-16">
            <p class="text-12 text-red relative left-0 leading-16" [id]="errorId" role="alert">
                {{ errorMsg() }}
            </p>
        </div>
    }
</div>
